import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
//import zhCn from "element-plus/lib/locale/lang/zh-cn";
   // 如果上面引入的包不行就用下面这个
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
   // 或者这个
//import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import store from './store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//import axios from 'axios';

// 创建一个 axios 实例
/*
const api = axios.create({
  baseURL: 'http://example.com/api', // 设置你的 API 基础 URL
  // 其他配置...
});
*/
// ============ 新增：ECharts + vue-echarts 全局配置 ============
import VChart from 'vue-echarts'

// 按需引入 ECharts 模块（根据你用的图表类型调整）
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
  LineChart,
  BarChart,
  PieChart,
  ScatterChart
} from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent
} from 'echarts/components'

// 注册所需模块（只需注册一次）
use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  ScatterChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent
])
// ==========================================================
const app = createApp(App);
// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 全局注册 VChart 组件（可在任意 .vue 文件中使用 <VChart />）
app.component('VChart', VChart)
//app.provide('axios', api);
app.use(store).use(router).use(ElementPlus,{locale: zhCn}).mount('#app')
